import { atom } from "recoil";

export const MenuState = atom<any>({
  key: "menuState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (initial state)
});
